// source: v1alpha1/pipelines.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var v1alpha1_common_pb = require('../v1alpha1/common_pb.js');
goog.object.extend(proto, v1alpha1_common_pb);
goog.exportSymbol('proto.pb.v1alpha1.AllRoute', null, global);
goog.exportSymbol('proto.pb.v1alpha1.CreatePipelineRequest', null, global);
goog.exportSymbol('proto.pb.v1alpha1.DefaultRoute', null, global);
goog.exportSymbol('proto.pb.v1alpha1.DeletePipelineRequest', null, global);
goog.exportSymbol('proto.pb.v1alpha1.DeletePipelineResponse', null, global);
goog.exportSymbol('proto.pb.v1alpha1.DeletedObjectInfo', null, global);
goog.exportSymbol('proto.pb.v1alpha1.GenreToEmailRoute', null, global);
goog.exportSymbol('proto.pb.v1alpha1.GetPipelineRequest', null, global);
goog.exportSymbol('proto.pb.v1alpha1.GmailTrigger', null, global);
goog.exportSymbol('proto.pb.v1alpha1.ListPipelinesRequest', null, global);
goog.exportSymbol('proto.pb.v1alpha1.ListPipelinesResponse', null, global);
goog.exportSymbol('proto.pb.v1alpha1.Pipeline', null, global);
goog.exportSymbol('proto.pb.v1alpha1.Pipeline.Status', null, global);
goog.exportSymbol('proto.pb.v1alpha1.PipelineDebugConfig', null, global);
goog.exportSymbol('proto.pb.v1alpha1.Routes', null, global);
goog.exportSymbol('proto.pb.v1alpha1.Triggers', null, global);
goog.exportSymbol('proto.pb.v1alpha1.UpdatePipelineRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.ListPipelinesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.v1alpha1.ListPipelinesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.ListPipelinesRequest.displayName = 'proto.pb.v1alpha1.ListPipelinesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.ListPipelinesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pb.v1alpha1.ListPipelinesResponse.repeatedFields_, null);
};
goog.inherits(proto.pb.v1alpha1.ListPipelinesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.ListPipelinesResponse.displayName = 'proto.pb.v1alpha1.ListPipelinesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.CreatePipelineRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.v1alpha1.CreatePipelineRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.CreatePipelineRequest.displayName = 'proto.pb.v1alpha1.CreatePipelineRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.GetPipelineRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.v1alpha1.GetPipelineRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.GetPipelineRequest.displayName = 'proto.pb.v1alpha1.GetPipelineRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.UpdatePipelineRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.v1alpha1.UpdatePipelineRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.UpdatePipelineRequest.displayName = 'proto.pb.v1alpha1.UpdatePipelineRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.DeletePipelineRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.v1alpha1.DeletePipelineRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.DeletePipelineRequest.displayName = 'proto.pb.v1alpha1.DeletePipelineRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.DeletePipelineResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.v1alpha1.DeletePipelineResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.DeletePipelineResponse.displayName = 'proto.pb.v1alpha1.DeletePipelineResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.Pipeline = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.v1alpha1.Pipeline, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.Pipeline.displayName = 'proto.pb.v1alpha1.Pipeline';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.Triggers = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.v1alpha1.Triggers, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.Triggers.displayName = 'proto.pb.v1alpha1.Triggers';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.GmailTrigger = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pb.v1alpha1.GmailTrigger.repeatedFields_, null);
};
goog.inherits(proto.pb.v1alpha1.GmailTrigger, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.GmailTrigger.displayName = 'proto.pb.v1alpha1.GmailTrigger';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.Routes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pb.v1alpha1.Routes.repeatedFields_, null);
};
goog.inherits(proto.pb.v1alpha1.Routes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.Routes.displayName = 'proto.pb.v1alpha1.Routes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.GenreToEmailRoute = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pb.v1alpha1.GenreToEmailRoute.repeatedFields_, null);
};
goog.inherits(proto.pb.v1alpha1.GenreToEmailRoute, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.GenreToEmailRoute.displayName = 'proto.pb.v1alpha1.GenreToEmailRoute';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.AllRoute = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pb.v1alpha1.AllRoute.repeatedFields_, null);
};
goog.inherits(proto.pb.v1alpha1.AllRoute, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.AllRoute.displayName = 'proto.pb.v1alpha1.AllRoute';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.DefaultRoute = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pb.v1alpha1.DefaultRoute.repeatedFields_, null);
};
goog.inherits(proto.pb.v1alpha1.DefaultRoute, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.DefaultRoute.displayName = 'proto.pb.v1alpha1.DefaultRoute';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.PipelineDebugConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.v1alpha1.PipelineDebugConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.PipelineDebugConfig.displayName = 'proto.pb.v1alpha1.PipelineDebugConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.DeletedObjectInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.v1alpha1.DeletedObjectInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.DeletedObjectInfo.displayName = 'proto.pb.v1alpha1.DeletedObjectInfo';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.ListPipelinesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.ListPipelinesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.ListPipelinesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.ListPipelinesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    user: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pageSize: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageToken: jspb.Message.getFieldWithDefault(msg, 3, ""),
    filter: jspb.Message.getFieldWithDefault(msg, 4, ""),
    orgResourceName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.ListPipelinesRequest}
 */
proto.pb.v1alpha1.ListPipelinesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.ListPipelinesRequest;
  return proto.pb.v1alpha1.ListPipelinesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.ListPipelinesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.ListPipelinesRequest}
 */
proto.pb.v1alpha1.ListPipelinesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUser(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageToken(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilter(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgResourceName(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.ListPipelinesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.ListPipelinesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.ListPipelinesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.ListPipelinesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUser();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFilter();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOrgResourceName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional string user = 1;
 * @return {string}
 */
proto.pb.v1alpha1.ListPipelinesRequest.prototype.getUser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.ListPipelinesRequest} returns this
 */
proto.pb.v1alpha1.ListPipelinesRequest.prototype.setUser = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_size = 2;
 * @return {number}
 */
proto.pb.v1alpha1.ListPipelinesRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pb.v1alpha1.ListPipelinesRequest} returns this
 */
proto.pb.v1alpha1.ListPipelinesRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string page_token = 3;
 * @return {string}
 */
proto.pb.v1alpha1.ListPipelinesRequest.prototype.getPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.ListPipelinesRequest} returns this
 */
proto.pb.v1alpha1.ListPipelinesRequest.prototype.setPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string filter = 4;
 * @return {string}
 */
proto.pb.v1alpha1.ListPipelinesRequest.prototype.getFilter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.ListPipelinesRequest} returns this
 */
proto.pb.v1alpha1.ListPipelinesRequest.prototype.setFilter = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string org_resource_name = 6;
 * @return {string}
 */
proto.pb.v1alpha1.ListPipelinesRequest.prototype.getOrgResourceName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.ListPipelinesRequest} returns this
 */
proto.pb.v1alpha1.ListPipelinesRequest.prototype.setOrgResourceName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 page_number = 7;
 * @return {number}
 */
proto.pb.v1alpha1.ListPipelinesRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.pb.v1alpha1.ListPipelinesRequest} returns this
 */
proto.pb.v1alpha1.ListPipelinesRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pb.v1alpha1.ListPipelinesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.ListPipelinesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.ListPipelinesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.ListPipelinesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.ListPipelinesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    pipelinesList: jspb.Message.toObjectList(msg.getPipelinesList(),
    proto.pb.v1alpha1.Pipeline.toObject, includeInstance),
    nextPageToken: jspb.Message.getFieldWithDefault(msg, 2, ""),
    totalSize: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.ListPipelinesResponse}
 */
proto.pb.v1alpha1.ListPipelinesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.ListPipelinesResponse;
  return proto.pb.v1alpha1.ListPipelinesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.ListPipelinesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.ListPipelinesResponse}
 */
proto.pb.v1alpha1.ListPipelinesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pb.v1alpha1.Pipeline;
      reader.readMessage(value,proto.pb.v1alpha1.Pipeline.deserializeBinaryFromReader);
      msg.addPipelines(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageToken(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.ListPipelinesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.ListPipelinesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.ListPipelinesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.ListPipelinesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPipelinesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pb.v1alpha1.Pipeline.serializeBinaryToWriter
    );
  }
  f = message.getNextPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotalSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * repeated Pipeline pipelines = 1;
 * @return {!Array<!proto.pb.v1alpha1.Pipeline>}
 */
proto.pb.v1alpha1.ListPipelinesResponse.prototype.getPipelinesList = function() {
  return /** @type{!Array<!proto.pb.v1alpha1.Pipeline>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pb.v1alpha1.Pipeline, 1));
};


/**
 * @param {!Array<!proto.pb.v1alpha1.Pipeline>} value
 * @return {!proto.pb.v1alpha1.ListPipelinesResponse} returns this
*/
proto.pb.v1alpha1.ListPipelinesResponse.prototype.setPipelinesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pb.v1alpha1.Pipeline=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pb.v1alpha1.Pipeline}
 */
proto.pb.v1alpha1.ListPipelinesResponse.prototype.addPipelines = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pb.v1alpha1.Pipeline, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.v1alpha1.ListPipelinesResponse} returns this
 */
proto.pb.v1alpha1.ListPipelinesResponse.prototype.clearPipelinesList = function() {
  return this.setPipelinesList([]);
};


/**
 * optional string next_page_token = 2;
 * @return {string}
 */
proto.pb.v1alpha1.ListPipelinesResponse.prototype.getNextPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.ListPipelinesResponse} returns this
 */
proto.pb.v1alpha1.ListPipelinesResponse.prototype.setNextPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 total_size = 3;
 * @return {number}
 */
proto.pb.v1alpha1.ListPipelinesResponse.prototype.getTotalSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.pb.v1alpha1.ListPipelinesResponse} returns this
 */
proto.pb.v1alpha1.ListPipelinesResponse.prototype.setTotalSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.CreatePipelineRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.CreatePipelineRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.CreatePipelineRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.CreatePipelineRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    pipeline: (f = msg.getPipeline()) && proto.pb.v1alpha1.Pipeline.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.CreatePipelineRequest}
 */
proto.pb.v1alpha1.CreatePipelineRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.CreatePipelineRequest;
  return proto.pb.v1alpha1.CreatePipelineRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.CreatePipelineRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.CreatePipelineRequest}
 */
proto.pb.v1alpha1.CreatePipelineRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pb.v1alpha1.Pipeline;
      reader.readMessage(value,proto.pb.v1alpha1.Pipeline.deserializeBinaryFromReader);
      msg.setPipeline(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.CreatePipelineRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.CreatePipelineRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.CreatePipelineRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.CreatePipelineRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPipeline();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pb.v1alpha1.Pipeline.serializeBinaryToWriter
    );
  }
};


/**
 * optional Pipeline pipeline = 1;
 * @return {?proto.pb.v1alpha1.Pipeline}
 */
proto.pb.v1alpha1.CreatePipelineRequest.prototype.getPipeline = function() {
  return /** @type{?proto.pb.v1alpha1.Pipeline} */ (
    jspb.Message.getWrapperField(this, proto.pb.v1alpha1.Pipeline, 1));
};


/**
 * @param {?proto.pb.v1alpha1.Pipeline|undefined} value
 * @return {!proto.pb.v1alpha1.CreatePipelineRequest} returns this
*/
proto.pb.v1alpha1.CreatePipelineRequest.prototype.setPipeline = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pb.v1alpha1.CreatePipelineRequest} returns this
 */
proto.pb.v1alpha1.CreatePipelineRequest.prototype.clearPipeline = function() {
  return this.setPipeline(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pb.v1alpha1.CreatePipelineRequest.prototype.hasPipeline = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.GetPipelineRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.GetPipelineRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.GetPipelineRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.GetPipelineRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.GetPipelineRequest}
 */
proto.pb.v1alpha1.GetPipelineRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.GetPipelineRequest;
  return proto.pb.v1alpha1.GetPipelineRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.GetPipelineRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.GetPipelineRequest}
 */
proto.pb.v1alpha1.GetPipelineRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.GetPipelineRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.GetPipelineRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.GetPipelineRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.GetPipelineRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.pb.v1alpha1.GetPipelineRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.GetPipelineRequest} returns this
 */
proto.pb.v1alpha1.GetPipelineRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.UpdatePipelineRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.UpdatePipelineRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.UpdatePipelineRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.UpdatePipelineRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    pipeline: (f = msg.getPipeline()) && proto.pb.v1alpha1.Pipeline.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.UpdatePipelineRequest}
 */
proto.pb.v1alpha1.UpdatePipelineRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.UpdatePipelineRequest;
  return proto.pb.v1alpha1.UpdatePipelineRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.UpdatePipelineRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.UpdatePipelineRequest}
 */
proto.pb.v1alpha1.UpdatePipelineRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pb.v1alpha1.Pipeline;
      reader.readMessage(value,proto.pb.v1alpha1.Pipeline.deserializeBinaryFromReader);
      msg.setPipeline(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.UpdatePipelineRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.UpdatePipelineRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.UpdatePipelineRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.UpdatePipelineRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPipeline();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pb.v1alpha1.Pipeline.serializeBinaryToWriter
    );
  }
};


/**
 * optional Pipeline pipeline = 1;
 * @return {?proto.pb.v1alpha1.Pipeline}
 */
proto.pb.v1alpha1.UpdatePipelineRequest.prototype.getPipeline = function() {
  return /** @type{?proto.pb.v1alpha1.Pipeline} */ (
    jspb.Message.getWrapperField(this, proto.pb.v1alpha1.Pipeline, 1));
};


/**
 * @param {?proto.pb.v1alpha1.Pipeline|undefined} value
 * @return {!proto.pb.v1alpha1.UpdatePipelineRequest} returns this
*/
proto.pb.v1alpha1.UpdatePipelineRequest.prototype.setPipeline = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pb.v1alpha1.UpdatePipelineRequest} returns this
 */
proto.pb.v1alpha1.UpdatePipelineRequest.prototype.clearPipeline = function() {
  return this.setPipeline(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pb.v1alpha1.UpdatePipelineRequest.prototype.hasPipeline = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.DeletePipelineRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.DeletePipelineRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.DeletePipelineRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.DeletePipelineRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    deletedReason: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.DeletePipelineRequest}
 */
proto.pb.v1alpha1.DeletePipelineRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.DeletePipelineRequest;
  return proto.pb.v1alpha1.DeletePipelineRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.DeletePipelineRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.DeletePipelineRequest}
 */
proto.pb.v1alpha1.DeletePipelineRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeletedReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.DeletePipelineRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.DeletePipelineRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.DeletePipelineRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.DeletePipelineRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDeletedReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.pb.v1alpha1.DeletePipelineRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.DeletePipelineRequest} returns this
 */
proto.pb.v1alpha1.DeletePipelineRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string deleted_reason = 2;
 * @return {string}
 */
proto.pb.v1alpha1.DeletePipelineRequest.prototype.getDeletedReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.DeletePipelineRequest} returns this
 */
proto.pb.v1alpha1.DeletePipelineRequest.prototype.setDeletedReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.DeletePipelineResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.DeletePipelineResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.DeletePipelineResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.DeletePipelineResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    temporalPipelineId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.DeletePipelineResponse}
 */
proto.pb.v1alpha1.DeletePipelineResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.DeletePipelineResponse;
  return proto.pb.v1alpha1.DeletePipelineResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.DeletePipelineResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.DeletePipelineResponse}
 */
proto.pb.v1alpha1.DeletePipelineResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTemporalPipelineId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.DeletePipelineResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.DeletePipelineResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.DeletePipelineResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.DeletePipelineResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTemporalPipelineId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string temporal_pipeline_id = 1;
 * @return {string}
 */
proto.pb.v1alpha1.DeletePipelineResponse.prototype.getTemporalPipelineId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.DeletePipelineResponse} returns this
 */
proto.pb.v1alpha1.DeletePipelineResponse.prototype.setTemporalPipelineId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.Pipeline.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.Pipeline.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.Pipeline} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.Pipeline.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    createdBy: jspb.Message.getFieldWithDefault(msg, 2, ""),
    creationTime: (f = msg.getCreationTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    triggers: (f = msg.getTriggers()) && proto.pb.v1alpha1.Triggers.toObject(includeInstance, f),
    routes: (f = msg.getRoutes()) && proto.pb.v1alpha1.Routes.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 6, 0),
    organizationName: jspb.Message.getFieldWithDefault(msg, 7, ""),
    pipelineType: jspb.Message.getFieldWithDefault(msg, 8, 0),
    deletedObjectInfo: (f = msg.getDeletedObjectInfo()) && proto.pb.v1alpha1.DeletedObjectInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.Pipeline}
 */
proto.pb.v1alpha1.Pipeline.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.Pipeline;
  return proto.pb.v1alpha1.Pipeline.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.Pipeline} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.Pipeline}
 */
proto.pb.v1alpha1.Pipeline.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedBy(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreationTime(value);
      break;
    case 4:
      var value = new proto.pb.v1alpha1.Triggers;
      reader.readMessage(value,proto.pb.v1alpha1.Triggers.deserializeBinaryFromReader);
      msg.setTriggers(value);
      break;
    case 5:
      var value = new proto.pb.v1alpha1.Routes;
      reader.readMessage(value,proto.pb.v1alpha1.Routes.deserializeBinaryFromReader);
      msg.setRoutes(value);
      break;
    case 6:
      var value = /** @type {!proto.pb.v1alpha1.Pipeline.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationName(value);
      break;
    case 8:
      var value = /** @type {!proto.pb.v1alpha1.PIPELINE_TYPE} */ (reader.readEnum());
      msg.setPipelineType(value);
      break;
    case 9:
      var value = new proto.pb.v1alpha1.DeletedObjectInfo;
      reader.readMessage(value,proto.pb.v1alpha1.DeletedObjectInfo.deserializeBinaryFromReader);
      msg.setDeletedObjectInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.Pipeline.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.Pipeline.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.Pipeline} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.Pipeline.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreatedBy();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCreationTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTriggers();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.pb.v1alpha1.Triggers.serializeBinaryToWriter
    );
  }
  f = message.getRoutes();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.pb.v1alpha1.Routes.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getOrganizationName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPipelineType();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getDeletedObjectInfo();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.pb.v1alpha1.DeletedObjectInfo.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.pb.v1alpha1.Pipeline.Status = {
  STATUS_UNSPECIFIED: 0,
  STATUS_ENABLED: 1,
  STATUS_DISABLED: 2
};

/**
 * optional string name = 1;
 * @return {string}
 */
proto.pb.v1alpha1.Pipeline.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.Pipeline} returns this
 */
proto.pb.v1alpha1.Pipeline.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string created_by = 2;
 * @return {string}
 */
proto.pb.v1alpha1.Pipeline.prototype.getCreatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.Pipeline} returns this
 */
proto.pb.v1alpha1.Pipeline.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp creation_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pb.v1alpha1.Pipeline.prototype.getCreationTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pb.v1alpha1.Pipeline} returns this
*/
proto.pb.v1alpha1.Pipeline.prototype.setCreationTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pb.v1alpha1.Pipeline} returns this
 */
proto.pb.v1alpha1.Pipeline.prototype.clearCreationTime = function() {
  return this.setCreationTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pb.v1alpha1.Pipeline.prototype.hasCreationTime = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Triggers triggers = 4;
 * @return {?proto.pb.v1alpha1.Triggers}
 */
proto.pb.v1alpha1.Pipeline.prototype.getTriggers = function() {
  return /** @type{?proto.pb.v1alpha1.Triggers} */ (
    jspb.Message.getWrapperField(this, proto.pb.v1alpha1.Triggers, 4));
};


/**
 * @param {?proto.pb.v1alpha1.Triggers|undefined} value
 * @return {!proto.pb.v1alpha1.Pipeline} returns this
*/
proto.pb.v1alpha1.Pipeline.prototype.setTriggers = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pb.v1alpha1.Pipeline} returns this
 */
proto.pb.v1alpha1.Pipeline.prototype.clearTriggers = function() {
  return this.setTriggers(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pb.v1alpha1.Pipeline.prototype.hasTriggers = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Routes routes = 5;
 * @return {?proto.pb.v1alpha1.Routes}
 */
proto.pb.v1alpha1.Pipeline.prototype.getRoutes = function() {
  return /** @type{?proto.pb.v1alpha1.Routes} */ (
    jspb.Message.getWrapperField(this, proto.pb.v1alpha1.Routes, 5));
};


/**
 * @param {?proto.pb.v1alpha1.Routes|undefined} value
 * @return {!proto.pb.v1alpha1.Pipeline} returns this
*/
proto.pb.v1alpha1.Pipeline.prototype.setRoutes = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pb.v1alpha1.Pipeline} returns this
 */
proto.pb.v1alpha1.Pipeline.prototype.clearRoutes = function() {
  return this.setRoutes(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pb.v1alpha1.Pipeline.prototype.hasRoutes = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Status status = 6;
 * @return {!proto.pb.v1alpha1.Pipeline.Status}
 */
proto.pb.v1alpha1.Pipeline.prototype.getStatus = function() {
  return /** @type {!proto.pb.v1alpha1.Pipeline.Status} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.pb.v1alpha1.Pipeline.Status} value
 * @return {!proto.pb.v1alpha1.Pipeline} returns this
 */
proto.pb.v1alpha1.Pipeline.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string organization_name = 7;
 * @return {string}
 */
proto.pb.v1alpha1.Pipeline.prototype.getOrganizationName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.Pipeline} returns this
 */
proto.pb.v1alpha1.Pipeline.prototype.setOrganizationName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional PIPELINE_TYPE pipeline_type = 8;
 * @return {!proto.pb.v1alpha1.PIPELINE_TYPE}
 */
proto.pb.v1alpha1.Pipeline.prototype.getPipelineType = function() {
  return /** @type {!proto.pb.v1alpha1.PIPELINE_TYPE} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.pb.v1alpha1.PIPELINE_TYPE} value
 * @return {!proto.pb.v1alpha1.Pipeline} returns this
 */
proto.pb.v1alpha1.Pipeline.prototype.setPipelineType = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional DeletedObjectInfo deleted_object_info = 9;
 * @return {?proto.pb.v1alpha1.DeletedObjectInfo}
 */
proto.pb.v1alpha1.Pipeline.prototype.getDeletedObjectInfo = function() {
  return /** @type{?proto.pb.v1alpha1.DeletedObjectInfo} */ (
    jspb.Message.getWrapperField(this, proto.pb.v1alpha1.DeletedObjectInfo, 9));
};


/**
 * @param {?proto.pb.v1alpha1.DeletedObjectInfo|undefined} value
 * @return {!proto.pb.v1alpha1.Pipeline} returns this
*/
proto.pb.v1alpha1.Pipeline.prototype.setDeletedObjectInfo = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pb.v1alpha1.Pipeline} returns this
 */
proto.pb.v1alpha1.Pipeline.prototype.clearDeletedObjectInfo = function() {
  return this.setDeletedObjectInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pb.v1alpha1.Pipeline.prototype.hasDeletedObjectInfo = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.Triggers.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.Triggers.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.Triggers} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.Triggers.toObject = function(includeInstance, msg) {
  var f, obj = {
    gmail: (f = msg.getGmail()) && proto.pb.v1alpha1.GmailTrigger.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.Triggers}
 */
proto.pb.v1alpha1.Triggers.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.Triggers;
  return proto.pb.v1alpha1.Triggers.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.Triggers} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.Triggers}
 */
proto.pb.v1alpha1.Triggers.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pb.v1alpha1.GmailTrigger;
      reader.readMessage(value,proto.pb.v1alpha1.GmailTrigger.deserializeBinaryFromReader);
      msg.setGmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.Triggers.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.Triggers.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.Triggers} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.Triggers.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGmail();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pb.v1alpha1.GmailTrigger.serializeBinaryToWriter
    );
  }
};


/**
 * optional GmailTrigger gmail = 1;
 * @return {?proto.pb.v1alpha1.GmailTrigger}
 */
proto.pb.v1alpha1.Triggers.prototype.getGmail = function() {
  return /** @type{?proto.pb.v1alpha1.GmailTrigger} */ (
    jspb.Message.getWrapperField(this, proto.pb.v1alpha1.GmailTrigger, 1));
};


/**
 * @param {?proto.pb.v1alpha1.GmailTrigger|undefined} value
 * @return {!proto.pb.v1alpha1.Triggers} returns this
*/
proto.pb.v1alpha1.Triggers.prototype.setGmail = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pb.v1alpha1.Triggers} returns this
 */
proto.pb.v1alpha1.Triggers.prototype.clearGmail = function() {
  return this.setGmail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pb.v1alpha1.Triggers.prototype.hasGmail = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pb.v1alpha1.GmailTrigger.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.GmailTrigger.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.GmailTrigger.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.GmailTrigger} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.GmailTrigger.toObject = function(includeInstance, msg) {
  var f, obj = {
    watchEmail: jspb.Message.getFieldWithDefault(msg, 1, ""),
    labelsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.GmailTrigger}
 */
proto.pb.v1alpha1.GmailTrigger.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.GmailTrigger;
  return proto.pb.v1alpha1.GmailTrigger.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.GmailTrigger} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.GmailTrigger}
 */
proto.pb.v1alpha1.GmailTrigger.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWatchEmail(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addLabels(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.GmailTrigger.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.GmailTrigger.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.GmailTrigger} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.GmailTrigger.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWatchEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabelsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string watch_email = 1;
 * @return {string}
 */
proto.pb.v1alpha1.GmailTrigger.prototype.getWatchEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.GmailTrigger} returns this
 */
proto.pb.v1alpha1.GmailTrigger.prototype.setWatchEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string labels = 2;
 * @return {!Array<string>}
 */
proto.pb.v1alpha1.GmailTrigger.prototype.getLabelsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pb.v1alpha1.GmailTrigger} returns this
 */
proto.pb.v1alpha1.GmailTrigger.prototype.setLabelsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pb.v1alpha1.GmailTrigger} returns this
 */
proto.pb.v1alpha1.GmailTrigger.prototype.addLabels = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.v1alpha1.GmailTrigger} returns this
 */
proto.pb.v1alpha1.GmailTrigger.prototype.clearLabelsList = function() {
  return this.setLabelsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pb.v1alpha1.Routes.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.Routes.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.Routes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.Routes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.Routes.toObject = function(includeInstance, msg) {
  var f, obj = {
    genreToEmailList: jspb.Message.toObjectList(msg.getGenreToEmailList(),
    proto.pb.v1alpha1.GenreToEmailRoute.toObject, includeInstance),
    defaultRoute: (f = msg.getDefaultRoute()) && proto.pb.v1alpha1.DefaultRoute.toObject(includeInstance, f),
    allRoute: (f = msg.getAllRoute()) && proto.pb.v1alpha1.AllRoute.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.Routes}
 */
proto.pb.v1alpha1.Routes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.Routes;
  return proto.pb.v1alpha1.Routes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.Routes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.Routes}
 */
proto.pb.v1alpha1.Routes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pb.v1alpha1.GenreToEmailRoute;
      reader.readMessage(value,proto.pb.v1alpha1.GenreToEmailRoute.deserializeBinaryFromReader);
      msg.addGenreToEmail(value);
      break;
    case 2:
      var value = new proto.pb.v1alpha1.DefaultRoute;
      reader.readMessage(value,proto.pb.v1alpha1.DefaultRoute.deserializeBinaryFromReader);
      msg.setDefaultRoute(value);
      break;
    case 3:
      var value = new proto.pb.v1alpha1.AllRoute;
      reader.readMessage(value,proto.pb.v1alpha1.AllRoute.deserializeBinaryFromReader);
      msg.setAllRoute(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.Routes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.Routes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.Routes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.Routes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGenreToEmailList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pb.v1alpha1.GenreToEmailRoute.serializeBinaryToWriter
    );
  }
  f = message.getDefaultRoute();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pb.v1alpha1.DefaultRoute.serializeBinaryToWriter
    );
  }
  f = message.getAllRoute();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pb.v1alpha1.AllRoute.serializeBinaryToWriter
    );
  }
};


/**
 * repeated GenreToEmailRoute genre_to_email = 1;
 * @return {!Array<!proto.pb.v1alpha1.GenreToEmailRoute>}
 */
proto.pb.v1alpha1.Routes.prototype.getGenreToEmailList = function() {
  return /** @type{!Array<!proto.pb.v1alpha1.GenreToEmailRoute>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pb.v1alpha1.GenreToEmailRoute, 1));
};


/**
 * @param {!Array<!proto.pb.v1alpha1.GenreToEmailRoute>} value
 * @return {!proto.pb.v1alpha1.Routes} returns this
*/
proto.pb.v1alpha1.Routes.prototype.setGenreToEmailList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pb.v1alpha1.GenreToEmailRoute=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pb.v1alpha1.GenreToEmailRoute}
 */
proto.pb.v1alpha1.Routes.prototype.addGenreToEmail = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pb.v1alpha1.GenreToEmailRoute, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.v1alpha1.Routes} returns this
 */
proto.pb.v1alpha1.Routes.prototype.clearGenreToEmailList = function() {
  return this.setGenreToEmailList([]);
};


/**
 * optional DefaultRoute default_route = 2;
 * @return {?proto.pb.v1alpha1.DefaultRoute}
 */
proto.pb.v1alpha1.Routes.prototype.getDefaultRoute = function() {
  return /** @type{?proto.pb.v1alpha1.DefaultRoute} */ (
    jspb.Message.getWrapperField(this, proto.pb.v1alpha1.DefaultRoute, 2));
};


/**
 * @param {?proto.pb.v1alpha1.DefaultRoute|undefined} value
 * @return {!proto.pb.v1alpha1.Routes} returns this
*/
proto.pb.v1alpha1.Routes.prototype.setDefaultRoute = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pb.v1alpha1.Routes} returns this
 */
proto.pb.v1alpha1.Routes.prototype.clearDefaultRoute = function() {
  return this.setDefaultRoute(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pb.v1alpha1.Routes.prototype.hasDefaultRoute = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional AllRoute all_route = 3;
 * @return {?proto.pb.v1alpha1.AllRoute}
 */
proto.pb.v1alpha1.Routes.prototype.getAllRoute = function() {
  return /** @type{?proto.pb.v1alpha1.AllRoute} */ (
    jspb.Message.getWrapperField(this, proto.pb.v1alpha1.AllRoute, 3));
};


/**
 * @param {?proto.pb.v1alpha1.AllRoute|undefined} value
 * @return {!proto.pb.v1alpha1.Routes} returns this
*/
proto.pb.v1alpha1.Routes.prototype.setAllRoute = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pb.v1alpha1.Routes} returns this
 */
proto.pb.v1alpha1.Routes.prototype.clearAllRoute = function() {
  return this.setAllRoute(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pb.v1alpha1.Routes.prototype.hasAllRoute = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pb.v1alpha1.GenreToEmailRoute.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.GenreToEmailRoute.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.GenreToEmailRoute.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.GenreToEmailRoute} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.GenreToEmailRoute.toObject = function(includeInstance, msg) {
  var f, obj = {
    targetEmailsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    genresList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.GenreToEmailRoute}
 */
proto.pb.v1alpha1.GenreToEmailRoute.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.GenreToEmailRoute;
  return proto.pb.v1alpha1.GenreToEmailRoute.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.GenreToEmailRoute} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.GenreToEmailRoute}
 */
proto.pb.v1alpha1.GenreToEmailRoute.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTargetEmails(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addGenres(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.GenreToEmailRoute.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.GenreToEmailRoute.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.GenreToEmailRoute} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.GenreToEmailRoute.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTargetEmailsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getGenresList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated string target_emails = 1;
 * @return {!Array<string>}
 */
proto.pb.v1alpha1.GenreToEmailRoute.prototype.getTargetEmailsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pb.v1alpha1.GenreToEmailRoute} returns this
 */
proto.pb.v1alpha1.GenreToEmailRoute.prototype.setTargetEmailsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pb.v1alpha1.GenreToEmailRoute} returns this
 */
proto.pb.v1alpha1.GenreToEmailRoute.prototype.addTargetEmails = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.v1alpha1.GenreToEmailRoute} returns this
 */
proto.pb.v1alpha1.GenreToEmailRoute.prototype.clearTargetEmailsList = function() {
  return this.setTargetEmailsList([]);
};


/**
 * repeated string genres = 2;
 * @return {!Array<string>}
 */
proto.pb.v1alpha1.GenreToEmailRoute.prototype.getGenresList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pb.v1alpha1.GenreToEmailRoute} returns this
 */
proto.pb.v1alpha1.GenreToEmailRoute.prototype.setGenresList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pb.v1alpha1.GenreToEmailRoute} returns this
 */
proto.pb.v1alpha1.GenreToEmailRoute.prototype.addGenres = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.v1alpha1.GenreToEmailRoute} returns this
 */
proto.pb.v1alpha1.GenreToEmailRoute.prototype.clearGenresList = function() {
  return this.setGenresList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pb.v1alpha1.AllRoute.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.AllRoute.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.AllRoute.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.AllRoute} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.AllRoute.toObject = function(includeInstance, msg) {
  var f, obj = {
    targetEmailsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.AllRoute}
 */
proto.pb.v1alpha1.AllRoute.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.AllRoute;
  return proto.pb.v1alpha1.AllRoute.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.AllRoute} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.AllRoute}
 */
proto.pb.v1alpha1.AllRoute.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTargetEmails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.AllRoute.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.AllRoute.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.AllRoute} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.AllRoute.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTargetEmailsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string target_emails = 1;
 * @return {!Array<string>}
 */
proto.pb.v1alpha1.AllRoute.prototype.getTargetEmailsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pb.v1alpha1.AllRoute} returns this
 */
proto.pb.v1alpha1.AllRoute.prototype.setTargetEmailsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pb.v1alpha1.AllRoute} returns this
 */
proto.pb.v1alpha1.AllRoute.prototype.addTargetEmails = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.v1alpha1.AllRoute} returns this
 */
proto.pb.v1alpha1.AllRoute.prototype.clearTargetEmailsList = function() {
  return this.setTargetEmailsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pb.v1alpha1.DefaultRoute.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.DefaultRoute.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.DefaultRoute.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.DefaultRoute} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.DefaultRoute.toObject = function(includeInstance, msg) {
  var f, obj = {
    targetEmailsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.DefaultRoute}
 */
proto.pb.v1alpha1.DefaultRoute.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.DefaultRoute;
  return proto.pb.v1alpha1.DefaultRoute.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.DefaultRoute} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.DefaultRoute}
 */
proto.pb.v1alpha1.DefaultRoute.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTargetEmails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.DefaultRoute.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.DefaultRoute.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.DefaultRoute} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.DefaultRoute.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTargetEmailsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string target_emails = 1;
 * @return {!Array<string>}
 */
proto.pb.v1alpha1.DefaultRoute.prototype.getTargetEmailsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pb.v1alpha1.DefaultRoute} returns this
 */
proto.pb.v1alpha1.DefaultRoute.prototype.setTargetEmailsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pb.v1alpha1.DefaultRoute} returns this
 */
proto.pb.v1alpha1.DefaultRoute.prototype.addTargetEmails = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.v1alpha1.DefaultRoute} returns this
 */
proto.pb.v1alpha1.DefaultRoute.prototype.clearTargetEmailsList = function() {
  return this.setTargetEmailsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.PipelineDebugConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.PipelineDebugConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.PipelineDebugConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.PipelineDebugConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    bypassCache: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.PipelineDebugConfig}
 */
proto.pb.v1alpha1.PipelineDebugConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.PipelineDebugConfig;
  return proto.pb.v1alpha1.PipelineDebugConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.PipelineDebugConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.PipelineDebugConfig}
 */
proto.pb.v1alpha1.PipelineDebugConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBypassCache(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.PipelineDebugConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.PipelineDebugConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.PipelineDebugConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.PipelineDebugConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBypassCache();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool bypass_cache = 1;
 * @return {boolean}
 */
proto.pb.v1alpha1.PipelineDebugConfig.prototype.getBypassCache = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pb.v1alpha1.PipelineDebugConfig} returns this
 */
proto.pb.v1alpha1.PipelineDebugConfig.prototype.setBypassCache = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.DeletedObjectInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.DeletedObjectInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.DeletedObjectInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.DeletedObjectInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    deletedTime: (f = msg.getDeletedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    deletedBy: jspb.Message.getFieldWithDefault(msg, 2, ""),
    deletedReason: jspb.Message.getFieldWithDefault(msg, 3, ""),
    unrestorableReason: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.DeletedObjectInfo}
 */
proto.pb.v1alpha1.DeletedObjectInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.DeletedObjectInfo;
  return proto.pb.v1alpha1.DeletedObjectInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.DeletedObjectInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.DeletedObjectInfo}
 */
proto.pb.v1alpha1.DeletedObjectInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDeletedTime(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeletedBy(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeletedReason(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnrestorableReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.DeletedObjectInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.DeletedObjectInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.DeletedObjectInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.DeletedObjectInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeletedTime();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDeletedBy();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDeletedReason();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUnrestorableReason();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp deleted_time = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pb.v1alpha1.DeletedObjectInfo.prototype.getDeletedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pb.v1alpha1.DeletedObjectInfo} returns this
*/
proto.pb.v1alpha1.DeletedObjectInfo.prototype.setDeletedTime = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pb.v1alpha1.DeletedObjectInfo} returns this
 */
proto.pb.v1alpha1.DeletedObjectInfo.prototype.clearDeletedTime = function() {
  return this.setDeletedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pb.v1alpha1.DeletedObjectInfo.prototype.hasDeletedTime = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string deleted_by = 2;
 * @return {string}
 */
proto.pb.v1alpha1.DeletedObjectInfo.prototype.getDeletedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.DeletedObjectInfo} returns this
 */
proto.pb.v1alpha1.DeletedObjectInfo.prototype.setDeletedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string deleted_reason = 3;
 * @return {string}
 */
proto.pb.v1alpha1.DeletedObjectInfo.prototype.getDeletedReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.DeletedObjectInfo} returns this
 */
proto.pb.v1alpha1.DeletedObjectInfo.prototype.setDeletedReason = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string unrestorable_reason = 4;
 * @return {string}
 */
proto.pb.v1alpha1.DeletedObjectInfo.prototype.getUnrestorableReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.DeletedObjectInfo} returns this
 */
proto.pb.v1alpha1.DeletedObjectInfo.prototype.setUnrestorableReason = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


goog.object.extend(exports, proto.pb.v1alpha1);
